import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Are you a boy scout coder?",
  "description": "",
  "published": "2012-01-17T00:00:00.000Z",
  "redirect_from": ["/blog/are-you-a-boy-scout-coder/swizec/3471"],
  "categories": "Boy Scout, Scout, Source code, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`The Boy Scouts have a rule: "Always leave the campground cleaner than you found it." If you find a mess on the ground, you clean it up regardless of who might have made the mess. /../ the original form by Robert Stephenson Smyth Baden-Powell, was "Try and leave this world a little better than you found it."`}</p>
      <p parentName="blockquote">{`What if we followed a similar rule in our code: "Always check a module in cleaner than when you checked it out." No matter who the original author was, what if we always made some effort, no matter how small, to improve the module. What would be the result?`}</p>
      <p parentName="blockquote">{`by `}<a parentName="p" {...{
          "href": "http://programmer.97things.oreilly.com/wiki/index.php/Uncle_Bob",
          "title": "Uncle Bob"
        }}>{`Uncle Bob`}</a>{` at `}<a parentName="p" {...{
          "href": "http://programmer.97things.oreilly.com/wiki/index.php/The_Boy_Scout_Rule"
        }}>{`O'Reilly commons`}</a></p>
    </blockquote>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Baden-Powell_family_%281917%29.jpg",
        "alt": "Lieut. Gen. Robert Stephenson Smyth Baden-Powe...",
        "title": "Lieut. Gen. Robert Stephenson Smyth Baden-Powe..."
      }}></img></p>
    <p>{`When I first saw this rule in Clean Code I loved it! It's just such an awesome rule. You come into a file, you clean it up a little bit. Remove a stupid comment, indent something better ... anything.`}</p>
    <p>{`It makes the world a better place and everyone a happy camper right?`}</p>
    <p>{`Well, this might be great in theory and work well when you are employed by a company where you will spend the next few years of your life. The software you're working on will live and grow with you, with your team. `}<em parentName="p">{`You`}</em>{` are the guy shouting "Fuck this! Who the fuck made this code! This is bloody impossible to maintain!" a year from now.`}</p>
    <p>{`For a freelancer the situation is a bit different.`}</p>
    <p>{`Here you are, plomped into the middle of an ongoing project. Decisions have been made, rabbit holes have been followed. The deadline is in a month and as a crack team of one specialist on a tight deadline, you're making nice gold per hour.`}</p>
    <p>{`Right there in front of you. A mess. Code so ugly, so horrible, it would make a grown man cry. You're just supposed to add a feature. Figure out the mess, add two or three lines of code, cross your fingers and hope for the best.`}</p>
    <p>{`Or should you rewrite the whole function?`}</p>
    <p>{`Rewriting would be the Right Thing (tm) to do. The code will be more maintainable, easier to test, it will save your client a bunch of money down the line. You won't be maintaining this so you have a responsible towards everyone coming after you to fix something.`}</p>
    <p>{`But, right now, right this very instance, you are strong-arming the poor client to pay more. Sure, you're making the code better, but they care about that one feature. Should you really spend three hours rewriting the code instead of one hour adding something and hoping for the best?`}</p>
    <p>{`On the other hand: When the messy code breaks, and it `}<em parentName="p">{`will`}</em>{` break, it will be your fault. You're the last guy who touched it. Not rewriting will come back to haunt you. The guy who maintains your code will curse you in their sleep and dream of delicious murder. And it's not even your code!`}</p>
    <p>{`So what do you do?`}</p>
    <p>{`Personally I always try to rewrite crappy code. Add testing suites. Anything I can do to make the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Codebase",
        "title": "Codebase"
      }}>{`codebase`}</a>{` better. But I always carefully explain the situation to my client. `}<em parentName="p">{`Why`}</em>{` am I doing this, `}<em parentName="p">{`how`}</em>{` is it benefiting `}<strong parentName="p">{`the client`}</strong>{`. It's important to make them understand I'm not just inventing work to rake in more gold.`}</p>
    <p>{`Clients are surprisingly permissive most of the time and I can sleep better at night. win-win!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.swaroopch.com/blog/coders-at-work/"
        }}>{`Two nuggets from Coders at Work book`}</a>{` (swaroopch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://majorknitter.typepad.com/major_knitter/2012/01/boy-scout-popcorn-for-the-troops.html"
        }}>{`Boy Scout Popcorn for the Troops`}</a>{` (majorknitter.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://arstechnica.com/gaming/news/2012/01/maniac-tentacle-mindbenders-of-atlantis-how-scummvm-kept-adventure-gaming-alive.ars"
        }}>{`Feature: Maniac Tentacle Mindbenders: How ScummVM's unpaid coders kept adventure gaming alive`}</a>{` (arstechnica.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://developers.slashdot.org/story/12/01/14/008236/code-cleanup-culls-libreoffice-cruft"
        }}>{`Code Cleanup Culls LibreOffice Cruft`}</a>{` (developers.slashdot.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=cd0845b8-94e0-47d9-ae15-be9f3afa1482",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      